"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BridgeProvider = void 0;
const bridge_connection_1 = require("./models/bridge-connection");
const core_1 = require("@okxconnect/core");
const bridge_connection_storage_1 = require("../bridge-connection-storage");
const constants_1 = require("../../utils/constants");
const ton_connect_tracker_1 = require("../../tracker/ton-connect-tracker");
class BridgeProvider {
    constructor(storage, appname = undefined, connectors) {
        this.storage = storage;
        this.type = 'http';
        this.listeners = [];
        this.walletConnectionSource = { "universalLink": core_1.standardUniversalLink };
        this.openUniversalLink = false;
        this.engine = new core_1.Engine(appname + "_okxton");
        this.engine.registerConnector(connectors);
        this.connectionStorage = new bridge_connection_storage_1.BridgeConnectionStorage(storage);
        this.tracker = new ton_connect_tracker_1.TonConnectTracker({
            OKXtonConnectSdkVersion: constants_1.OKXtonConnectSdkVersion
        });
        (0, core_1.getDefaultReporter)().configVersionAndSide('tonsdk-1.5.2', 'dapp', appname);
    }
    static fromStorage(storage_1) {
        return __awaiter(this, arguments, void 0, function* (storage, appname = undefined, connectors) {
            (0, core_1.logDebug)('bridge-provider ==>> fromStorage ==>>storage:', storage);
            (0, core_1.reportLog)('bridge-provider ==>> fromStorage');
            const bridgeConnectionStorage = new bridge_connection_storage_1.BridgeConnectionStorage(storage);
            const connection = yield bridgeConnectionStorage.getHttpConnection();
            if ((0, bridge_connection_1.isPendingConnectionHttp)(connection)) {
                return null;
            }
            const provider = new BridgeProvider(storage, appname, connectors);
            provider.openUniversalLink = connection.openUniversalLink;
            return provider;
        });
    }
    isCryptoEnable() {
        const cryptoEnable = this.engine.connectionManager.getCryptoKeyEnable();
        return cryptoEnable;
    }
    connect(message, redirect, openUniversalLink, tmaReturnUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, core_1.logDebug)('bridge-provider ==>> connect_1 ==>>message:', message);
            (0, core_1.logDebug)('bridge-provider ==>> connect_1 ==>>redirect:', redirect);
            (0, core_1.logDebug)('bridge-provider ==>> connect_1 ==>>openUniversalLink:', openUniversalLink);
            (0, core_1.logDebug)('bridge-provider ==>> connect_1 ==>>tmaReturnUrl:', tmaReturnUrl);
            (0, core_1.reportLog)('bridge-provider ==>> connect');
            return new Promise((resolve, reject) => {
                try {
                    this.openUniversalLink = openUniversalLink;
                    if (this.openUniversalLink === undefined) {
                        this.openUniversalLink = (0, core_1.isMobileUserAgent)();
                    }
                    let tonNameSpace = {
                        namespace: "ton",
                        chains: ["ton:-239"],
                        params: message.params,
                    };
                    let tonRequest = {
                        name: "requestAccounts",
                        requiredNamespaces: [tonNameSpace]
                    };
                    let engineRequest = [];
                    // Easy to identify tonsdk
                    if (message.params.ton_addr) {
                        engineRequest.push(message.params.ton_addr);
                    }
                    if (message.params.ton_proof) {
                        engineRequest.push(message.params.ton_proof);
                    }
                    engineRequest.push(tonRequest); //Universal data
                    let config = {
                        dappInfo: message.dappInfo,
                        openUniversalUrl: this.openUniversalLink,
                        redirect: redirect,
                        tmaReturnUrl: tmaReturnUrl,
                    };
                    this.engine.universalConnect(engineRequest, config, (info) => {
                        (0, core_1.logDebug)(`bridge-provider: connect: info>>>> ${JSON.stringify(info)}`);
                        try {
                            const base64Encoded = (0, core_1.encodeConnectParams)(info.connectRequest);
                            const deepLink = (0, core_1.getAppWalletDeepLink)(base64Encoded);
                            const universalUrl = (0, core_1.getUniversalLink)(deepLink);
                            this.tracker.trackConnectionInfoBeforeJump(info);
                            resolve(universalUrl);
                        }
                        catch (error) {
                            reject(error);
                        }
                    }).then((session) => {
                        (0, core_1.logDebug)(`bridge-provider: connect: success>>>> ${JSON.stringify(session)}`);
                        this.connectSuccessHandle(session);
                    }).catch((e) => {
                        (0, core_1.logDebug)(`bridge-provider: connect: catch>>>> ${JSON.stringify(e)}`);
                        const errorMessage = {
                            event: 'connect_error',
                            requestId: Number(Date.now()),
                            payload: {
                                code: e.code,
                                message: e.message,
                            },
                        };
                        (0, core_1.logDebug)('bridge-provider ==>> connectListener_4 ==>>connect_error:', errorMessage);
                        this.listeners.forEach(listener => listener(errorMessage));
                        reject(e);
                    });
                }
                catch (error) {
                    console.error('bridge-provider connect try catch error:>>>', JSON.stringify(error));
                    reject(error);
                }
            });
        });
    }
    listen(callback) {
        this.listeners.push(callback);
        return () => (this.listeners = this.listeners.filter(listener => listener !== callback));
    }
    disconnectListener() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, core_1.logDebug)('bridge-provider ==>> disconnectListener');
            (0, core_1.reportLog)('bridge-provider ==>> disconnectListener');
            const disconnectMessage = {
                event: 'disconnect',
                requestId: Number(1),
                payload: {},
            };
            this.listeners.forEach(listener => listener(disconnectMessage));
            yield this.closeConnection();
        });
    }
    connectSuccessHandle(response) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            try {
                const namespaces = (_a = response.namespaces) === null || _a === void 0 ? void 0 : _a["ton"];
                const payload = namespaces.payload;
                const wallet = response.wallet;
                if (!namespaces || !payload || !wallet || !payload.ton_addr) {
                    throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR);
                }
                const ton_addr = payload.ton_addr;
                const sessionConfig = response.sessionConfig;
                let itemArr = [];
                if (payload.ton_addr) {
                    itemArr.push(payload.ton_addr);
                }
                if (payload.ton_proof) {
                    itemArr.push(payload.ton_proof);
                }
                const tonDeviceInfo = {
                    platform: wallet.platform,
                    appName: wallet.appName,
                    appVersion: wallet.appVersion,
                    maxProtocolVersion: wallet.maxProtocolVersion,
                    features: ['ton_sendTransaction'],
                };
                const tonConnectInfo = {
                    type: 'http',
                    lastWalletEventId: Number(Date.now()),
                    connectEvent: {
                        event: 'connect',
                        payload: {
                            items: itemArr,
                            device: tonDeviceInfo,
                        },
                    },
                    connectionSource: this.walletConnectionSource,
                    channelId: response.topic,
                    openUniversalLink: sessionConfig === null || sessionConfig === void 0 ? void 0 : sessionConfig.openUniversalUrl,
                };
                (0, core_1.logDebug)('bridge-provider ==>> connectSuccessHandle_2 ==>>storeConnection:', tonConnectInfo);
                yield this.connectionStorage.storeConnection(tonConnectInfo);
                (_b = this.engine) === null || _b === void 0 ? void 0 : _b.addDisconnectListener(this.disconnectListener.bind(this));
                const successMessage = {
                    event: 'connect',
                    requestId: tonConnectInfo.lastWalletEventId,
                    payload: tonConnectInfo.connectEvent.payload,
                };
                (0, core_1.logDebug)('bridge-provider ==>> connectSuccessHandle_3 ==>>listeners.forEach:', successMessage);
                this.listeners.forEach(listener => listener(successMessage));
            }
            catch (error) {
                (0, core_1.logDebug)('bridge-provider ==>> connectSuccessHandle_4 ==>>error:', error);
                const errorMessage = {
                    event: 'connect_error',
                    requestId: Number(Date.now()),
                    payload: {
                        code: core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR,
                        message: "Connect success  connectSuccessHandle response error",
                    },
                };
                (0, core_1.logDebug)('bridge-provider ==>> connectSuccessHandle_4 ==>>connect_error:', errorMessage);
                this.listeners.forEach(listener => listener(errorMessage));
            }
        });
    }
    closeConnection() {
        return __awaiter(this, arguments, void 0, function* (fromRestore = false, needOpenUrl = false) {
            var _a, _b;
            (0, core_1.logDebug)('bridge-provider ==>> closeConnection ==>>fromRestore:', fromRestore, ' needOpenUrl:', needOpenUrl);
            (0, core_1.reportLog)('bridge-provider ==>> closeConnection');
            this.listeners = [];
            if (!needOpenUrl) {
                yield ((_a = this.engine) === null || _a === void 0 ? void 0 : _a.connectManagerDisconnect(fromRestore));
            }
            if (!fromRestore) {
                (_b = this.engine) === null || _b === void 0 ? void 0 : _b.clearData();
                yield this.connectionStorage.removeConnection();
            }
        });
    }
    restoreConnection() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            (0, core_1.logDebug)('bridge-provider ==>> restoreConnection_1');
            (0, core_1.reportLog)('bridge-provider ==>> restoreConnection');
            const storedConnection = yield this.connectionStorage.getHttpConnection();
            const cryptoEnable = this.engine.connectionManager.getCryptoKeyEnable();
            if (!storedConnection || !cryptoEnable) {
                return;
            }
            if ((0, bridge_connection_1.isPendingConnectionHttp)(storedConnection)) {
                return;
            }
            (0, core_1.logDebug)('bridge-provider ==>> restoreConnection_2 ==>>storedConnection.channelId:', storedConnection.channelId);
            if (storedConnection.channelId) {
                try {
                    const successMessage = {
                        event: 'connect',
                        requestId: Number(0),
                        payload: storedConnection.connectEvent.payload,
                    };
                    this.listeners.forEach(listener => listener(successMessage));
                    this.engine.setConnectConnector(storedConnection.connectEvent.payload.device);
                    const channelId = storedConnection.channelId;
                    (0, core_1.logDebug)('bridge-provider ==>> restoreConnection_3 ==>>this.engine.restoreConnect:', channelId);
                    (_a = this.engine) === null || _a === void 0 ? void 0 : _a.addDisconnectListener(this.disconnectListener.bind(this));
                    yield this.engine.restoreconnectFromTopic(channelId);
                }
                catch (e) {
                    (0, core_1.logDebug)('bridge-provider ==>> restoreConnection_4 ==>>closeConnection_1');
                    yield this.closeConnection();
                }
            }
            else {
                (0, core_1.logDebug)('bridge-provider ==>> restoreConnection_4 ==>>closeConnection_2');
                yield this.closeConnection();
            }
        });
    }
    openOKXWallet() {
        (0, core_1.logDebug)('bridge-provider ==>> openOKXWallet', this.openUniversalLink);
        (0, core_1.reportLog)('bridge-provider ==>> openOKXWallet');
        if (this.openUniversalLink) {
            (0, core_1.openOKXDeeplink)(core_1.standardDeeplink);
        }
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, core_1.logDebug)('bridge-provider ==>> disconnect_1');
            (0, core_1.reportLog)('bridge-provider ==>> disconnect');
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                let called = false;
                const onRequestSent = () => {
                    if (!called) {
                        called = true;
                        this.closeConnection().then(resolve);
                    }
                };
                try {
                    yield this.sendRequest({ method: 'disconnect' }, { onRequestSent: onRequestSent, attempts: 1 });
                }
                catch (e) {
                    if (!called) {
                        this.closeConnection().then(resolve);
                    }
                }
                finally {
                    onRequestSent();
                }
            }));
        });
    }
    sendRequest(request, options, ttl) {
        (0, core_1.logDebug)('bridge-provider ==>> sendRequest');
        (0, core_1.reportLog)('bridge-provider ==>> sendRequest');
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                yield ((_a = this.engine) === null || _a === void 0 ? void 0 : _a.send(request, {
                    resolve: function (response) {
                        resolve(response);
                    },
                    onAck: function () {
                        var _a;
                        (_a = options === null || options === void 0 ? void 0 : options.onRequestSent) === null || _a === void 0 ? void 0 : _a.call(options);
                    }
                }, ttl));
            }
            catch (e) {
                reject(e);
            }
        }));
    }
    connectorOpenWallet() {
        this.engine.openWallet();
    }
}
exports.BridgeProvider = BridgeProvider;
